/**
 * @generated SignedSource<<db7ed475cb443cb55464f8f68dd1810f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type loginStepsQuery$variables = {};
export type loginStepsQuery$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly accounts: ReadonlyArray<{
          readonly id: string;
          readonly isDeleted: boolean;
          readonly name: string;
          readonly registeredAt: string;
        }>;
      } | null;
    };
  };
};
export type loginStepsQuery = {
  response: loginStepsQuery$data;
  variables: loginStepsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerQueryType",
    "kind": "LinkedField",
    "name": "Viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthViewerSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrentUser",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "accounts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginStepsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginStepsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bd78ed9b4a51dd7117555fd5fb02f70e",
    "id": null,
    "metadata": {},
    "name": "loginStepsQuery",
    "operationKind": "query",
    "text": "query loginStepsQuery {\n  Viewer {\n    Auth {\n      currentUser {\n        accounts {\n          id\n          name\n          isDeleted\n          registeredAt\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "17f6313ea8a1c7deaf5be6f36c105844";

export default node;
